// Caching mechanism for ratings
const API_RATING_CACHE_TTL = 86400000 // 24 hrs
const API_RATING_CACHE_PREFIX = 'n-ratings-'

const setWithExpiry = (key, value) => {
    const now = new Date()

    // 'item' is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
        value: value,
        expiry: now.getTime() + API_RATING_CACHE_TTL
    }
    localStorage.setItem(key, JSON.stringify(item))
}

const getWithExpiry = key => {
    const itemStr = localStorage.getItem(key)
    if (!itemStr) return undefined

    const item = JSON.parse(itemStr)
    const now = new Date()

    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage and return null
        localStorage.removeItem(key)
        return undefined
    }

    return item.value
}

export const getEncodedProductId = longSku => window.btoa(longSku)

export const getRatingDetails = async sku => {
    const key = `${API_RATING_CACHE_PREFIX}${sku}`
    let data = getWithExpiry(key)
    if (data === undefined) {
        // already expired or not cached
        data = await window.napi.ratings().summary(sku)
        setWithExpiry(key, data)
    }
    return data
}

export const isRatingEnabled = product =>
    product.productRatings && product.productRatings.ratingEnabled

export const isRated = (productRatings, minimum_rating) =>
    productRatings.reviewCount > 0 &&
    productRatings.ratingAverage > 0 &&
    productRatings.ratingAverage >= minimum_rating

export const getRatingPercentage = ratingSpread => {
    const ratingAverageSum = ratingSpread.reduce((partialSum, value) => partialSum + value, 0)

    return ratingSpread.map(element => {
        return (element / ratingAverageSum) * 100
    })
}

export const checkIfReviewsAvailable = ratingsResult => ratingsResult.reviewCount > 0

export const getProductReviews = async (
    market,
    language,
    encodedProductId,
    sort = 'highlightedFirst',
    page = 0
) => {
    const url = `/ecapi/rating/v1/${market}/${language}/${encodedProductId}/read?platform=desktop&page=${page}&sort=${sort}`
    const response = await fetch(url)

    return response.json()
}

export const postLike = async (market, language, encodedProductId, reviewId) => {
    const url = `/ecapi/rating/v1/${market}/${language}/${encodedProductId}/${reviewId}/like`

    const response = await fetch(url, {
        method: 'POST'
    })

    return response.json()
}

export const getNapiProductReviews = async (sku, sort = 'highlightedFirst', page = 0) => {
    return window.napi.ratings().read(sku, sort, page)
}

export const postNapiLike = async (sku, reviewId) => {
    return window.napi.ratings().like(sku, reviewId)
}
